import { callApi } from 'helpers/saga-helpers';
import {
  requestAllFeeNotes,
  requestSetKpiOverdueInvoice,
  setFeeNotes,
  setFeeNotesSearch,
} from 'containers/LawyerFeeNote/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { isNull, get } from 'lodash';
import { put, select, takeLeading } from 'redux-saga/effects';
import {
  REQUEST_CREATE_FEE_NOTE,
  REQUEST_CREATE_FEE_NOTE_COSTS,
  REQUEST_FEE_NOTES,
  REQUEST_LAWYER_FEE_NOTES,
  REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER,
  REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER,
  REQUEST_UPDATE_FEE_NOTE_AMOUNT,
  REQUEST_UPDATE_FEE_NOTE,
  REQUEST_ADD_INVOICE_FEE_NOTE,
  REQUEST_UPDATE_INVOICE_FEE_NOTE,
  REQUEST_ALL_LAWYER_FEE_NOTES,
  REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER,
  REQUEST_UPDATE_FIRM_REFERENCE_MANAGER,
  REQUEST_REJECT_FEE_NOTE_LAWYER,
  REQUEST_GET_KPI_OVERDUE_INVOICE,
} from 'containers/LawyerFeeNote/constants';
import userToken from 'containers/services/security/access-token-storage';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { createFeeNoteAction } from 'containers/LawyerFeeNote/typings';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';

export function* requestFeeNotes(action: {
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const { page, pageSize } = action;

  const path = `/corporeal/fee-note?page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(
    path,
    {},
    options,
    [],
    setFeeNotes,
    undefined,
    false,
    LOADERS.FEE_NOTE,
  );
}
export function* requestFeeNotesSaga() {
  yield takeLeading(REQUEST_FEE_NOTES, requestFeeNotes);
}
export function* requestLawyerFeeNotes(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const { page, pageSize, status } = action;

  const path = `/corporeal/fee-note?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotes);
}
export function* requestAllLawyerFeeNotes(action: {
  status: string;
  type: string;
}): Generator<unknown> {
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const { status } = action;

  const path = `/corporeal/fee-note?status=${status}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(
    path,
    {},
    options,
    [],
    setFeeNotes,
    undefined,
    false,
    LOADERS.FEE_NOTE,
  );
}
export function* requestAllLawyerFeeNotesSaga() {
  yield takeLeading(REQUEST_ALL_LAWYER_FEE_NOTES, requestAllLawyerFeeNotes);
}
export function* requestLawyerFeeNotesSaga() {
  yield takeLeading(REQUEST_LAWYER_FEE_NOTES, requestLawyerFeeNotes);
}

export function* requestCreateFeeNote(
  action: createFeeNoteAction,
): Generator<unknown> {
  const { feeNote, successCallBack } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/lawyer`;
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...feeNote,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield put(requestClaimRecap(feeNote.claimId));
    yield successCallBack();
  }
}
export function* requestFeeNoteCosts(
  action: createFeeNoteAction,
): Generator<unknown> {
  const { feeNote, successCallBack } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/add-fee-costs?isIntervenant=true`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...feeNote,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestCreateFeeNoteSaga() {
  yield takeLeading(REQUEST_CREATE_FEE_NOTE, requestCreateFeeNote);
}
export function* requestCreateFeeNoteCostsSaga() {
  yield takeLeading(REQUEST_CREATE_FEE_NOTE_COSTS, requestFeeNoteCosts);
}
export function* requestFeeNotesBySinistre(action: {
  page: number;
  pageSize: number;
  claimNumber: string;
  type: string;
}): Generator<unknown> {
  const { claimNumber } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/GetByClaimNum/${claimNumber}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch);
}
export function* requestFeeNotesBySinistreSaga() {
  yield takeLeading(
    REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER,
    requestFeeNotesBySinistre,
  );
}

export function* requestFeeNotesByPolicyNumber(action: {
  page: number;
  pageSize: number;
  policyNumber: string;
  type: string;
}): Generator<unknown> {
  const { policyNumber } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/GetByPolicyNumber/${policyNumber}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch, (data: any) => {
    return { data: { ...data } };
  });
}
export function* requestFeeNotesByPolicyNumberSaga() {
  yield takeLeading(
    REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER,
    requestFeeNotesByPolicyNumber,
  );
}
export function* requestUpdateFeeNoteAmount(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;

  if (isNull(token)) return;
  const path = `/corporeal/fee-note/change-amount`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestUpdateFeeNoteAmountSaga() {
  yield takeLeading(REQUEST_UPDATE_FEE_NOTE_AMOUNT, requestUpdateFeeNoteAmount);
}
export function* requestUpdateFeeNoteStatus(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get()?.token;

  if (isNull(token)) return;
  const path = `/corporeal/fee-note/change-fee-note`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestUpdateFeeNoteStatusSaga() {
  yield takeLeading(REQUEST_UPDATE_FEE_NOTE, requestUpdateFeeNoteStatus);
}
export function* requestAddInvoiceFeeNote(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());

  if (isNull(token)) return;
  const path = `/corporeal/invoice-fee-note/add`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestAddInvoiceFeeNoteSaga() {
  yield takeLeading(REQUEST_ADD_INVOICE_FEE_NOTE, requestAddInvoiceFeeNote);
}
export function* requestUpdateInvoiceFeeNote(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());

  if (isNull(token)) return;
  const path = `/corporeal/invoice-fee-note/change`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestUpdateInvoiceFeeNoteSaga() {
  yield takeLeading(
    REQUEST_UPDATE_INVOICE_FEE_NOTE,
    requestUpdateInvoiceFeeNote,
  );
}
export function* requestFeeNotesByRegistrationNumber(action: {
  page: number;
  pageSize: number;
  registrationNumber: string;
  type: string;
}): Generator<unknown> {
  const { registrationNumber } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/GetByRegistrationNumber/${registrationNumber}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch, (data: any) => {
    return { data: { ...data } };
  });
}
export function* requestFeeNotesByRegistrationNumberSaga() {
  yield takeLeading(
    REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER,
    requestFeeNotesByRegistrationNumber,
  );
}

export function* updateFirmReferenceManager(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const { viewByClaim, claimNumber } = payload;
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/assignment/change-firm-reference-manager`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallBack();
    if (viewByClaim) {
      yield put(requestSagisClaimInfo(claimNumber, () => {}));
    }
  }
}

export function* updateFirmReferenceManagerSaga() {
  yield takeLeading(
    REQUEST_UPDATE_FIRM_REFERENCE_MANAGER,
    updateFirmReferenceManager,
  );
}

export function* requestRejectFeeNoteLawyer(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = yield select(makeSelectKeycloakToken());

  if (isNull(token)) return;
  const path = `/corporeal/fee-note/reject-fee-note-intervenant`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(requestAllFeeNotes(0, 25));
  }
}

export function* updateRejectFeeNoteByLawyerSaga() {
  yield takeLeading(REQUEST_REJECT_FEE_NOTE_LAWYER, requestRejectFeeNoteLawyer);
}

export function* requestGetKpiOverdueInvoice(action: any): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (!token) return;

  const path = `/corporeal/fee-note/kpi-overdue-invoice`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], requestSetKpiOverdueInvoice);
}

export function* requestGetKpiOverdueInvoiceSaga() {
  yield takeLeading(
    REQUEST_GET_KPI_OVERDUE_INVOICE,
    requestGetKpiOverdueInvoice,
  );
}
export default [
  requestFeeNotesSaga,
  requestCreateFeeNoteSaga,
  requestCreateFeeNoteCostsSaga,
  requestLawyerFeeNotesSaga,
  requestFeeNotesBySinistreSaga,
  requestFeeNotesByPolicyNumberSaga,
  requestUpdateFeeNoteAmountSaga,
  requestUpdateFeeNoteStatusSaga,
  requestAddInvoiceFeeNoteSaga,
  requestUpdateInvoiceFeeNoteSaga,
  requestAllLawyerFeeNotesSaga,
  requestFeeNotesByRegistrationNumberSaga,
  updateFirmReferenceManagerSaga,
  updateRejectFeeNoteByLawyerSaga,
  requestGetKpiOverdueInvoiceSaga,
];
